import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { CELL_SETS_CLUSTERING_UPDATED } from 'redux/actionTypes/cellSets';
import loadCellSets from './loadCellSets';
var updateCellSetsClustering = function updateCellSetsClustering(experimentId) {
  var cellClassesToLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: CELL_SETS_CLUSTERING_UPDATED
            });
            dispatch(loadCellSets(experimentId, {
              cellClassesToLoad: cellClassesToLoad,
              forceReload: true
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateCellSetsClustering;